import * as React from "react"
const SvgRepeat = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12.05 20.143q-3.35 0-5.7-2.325T4 12.143v-.175l-.9.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.426.275-.7l2.6-2.6q.3-.3.7-.3t.7.3l2.6 2.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-.9-.9v.175q0 2.5 1.763 4.25t4.287 1.75q.401 0 .787-.05.388-.05.763-.175.425-.126.8.025c.375.151.442.275.575.525a.9.9 0 0 1 .037.787.87.87 0 0 1-.587.513 6.4 6.4 0 0 1-1.175.287q-.6.088-1.2.088m-.1-14q-.401 0-.787.05a4 4 0 0 0-.763.175 1.23 1.23 0 0 1-.812-.025A1.1 1.1 0 0 1 9 5.818a.85.85 0 0 1-.037-.763.86.86 0 0 1 .562-.512q.6-.201 1.2-.3a7.4 7.4 0 0 1 1.225-.1q3.35 0 5.7 2.325T20 12.143v.175l.9-.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-2.6 2.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.6-2.6a.95.95 0 0 1-.275-.7q0-.426.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l.9.9v-.175q0-2.5-1.762-4.25t-4.288-1.75" />
  </svg>
)
export default SvgRepeat
